import { colors } from '../../colors';
var location = {
  bgColor: colors.lightGrey,
  cardBgColor: colors.white,
  secondaryBgColor: colors.black,
  cardShadow: colors.pureBlack,
  addressAccent: colors.rose
};
export default location;